import { render, staticRenderFns } from "./SinglePackageTest.vue?vue&type=template&id=3ec0ffb8&"
import script from "./SinglePackageTest.vue?vue&type=script&lang=js&"
export * from "./SinglePackageTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports